import React from "react";
import styled from "styled-components/macro";
import { Grid as Loader } from "react-loader-spinner";

const LoaderContainer = styled.div<LoaderContainerParams>`
    position: absolute;
    background: ${({ background }) => background || "none"};
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

interface LoaderContainerParams {
    background: string | undefined;
}

export const AppLoader = ({
    color,
    height,
    width,
    background = undefined,
}: {
    color: string;
    height: string | number;
    width: string | number;
    background?: string;
}) => {
    return (
        <LoaderContainer background={background}>
            <Loader color={color} height={height} width={width} />
        </LoaderContainer>
    );
};
